import { z } from 'zod';
import { CATEGORY_KINDS, type CategoryKind } from '../types';

export const categoryCreateSchema = z.object({
  name: z.string().trim().min(1, 'Nom obligatoire').max(60),
  kind: z.enum(CATEGORY_KINDS),
  icon: z.string().trim().max(8).optional(),
  color: z.string().trim().max(20).nullable().optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export const categoryUpdateSchema = categoryCreateSchema.partial();

export type CategoryCreateInput = z.infer<typeof categoryCreateSchema>;
export type CategoryUpdateInput = z.infer<typeof categoryUpdateSchema>;

export interface CategoryResponse {
  id: string;
  name: string;
  kind: CategoryKind;
  icon: string;
  color: string | null;
  sortOrder: number;
  archivedAt: string | null;
}
